/**
 * Мок расхода — правдоподобные цифры небольшой платформы: пара клиник с
 * ассистентом, напоминания в WhatsApp, ставки заданы.
 */

import dayjs from 'dayjs';

import type {ClinicUsage, PlatformUsage, RateCard, UsageTotals} from './types';

export const MOCK_RATE_CARD: RateCard = {
  aiInputPerMtok: 2_600,
  aiOutputPerMtok: 10_400,
  waUtility: 360,
  waMarketing: 2_150,
  waAuthentication: 340,
};

const totals = (k: number): UsageTotals => ({
  modelCalls: 68 * k,
  inputTokens: 250_077 * k,
  outputTokens: 3_146 * k,
  cachedTokens: 120_400 * k,
  assistantReplies: 41 * k,
  dialogs: 12 * k,
  waSent: 95 * k,
  waUtility: 38 * k,
  waMarketing: 0,
  waAuthentication: 2 * k,
  waBillableOther: 0,
  waServiceFree: 55 * k,
  voiceCalls: 23 * k,
  voiceInputTokens: 41_300 * k,
  voiceOutputTokens: 1_840 * k,
});

export const mockPlatformUsage = (period: string): PlatformUsage => ({
  period,
  clinics: [
    {clinicId: 'c-1', clinicName: 'Дента Плюс', totals: totals(3), estimatedCostTiyin: 61_840},
    {clinicId: 'c-2', clinicName: 'Смайл Ош', totals: totals(1), estimatedCostTiyin: 20_610},
  ],
  totals: totals(4),
  estimatedCostTiyin: 82_450,
  rateCard: MOCK_RATE_CARD,
});

export const mockClinicUsage = (from: string, to: string): ClinicUsage => ({
  dateFrom: from,
  dateTo: to,
  days: [0, 1, 3, 6].map((d) => ({
    day: dayjs(from).add(d, 'day').format('YYYY-MM-DD'),
    totals: totals(1),
  })),
  totals: totals(4),
  estimatedCostTiyin: 82_450,
  rateCard: MOCK_RATE_CARD,
});
